import { classNames } from '~/utils/styles';

type Size = 'small' | 'regular' | 'big';

export type LoadingProps = {
    size?: Size;
    compact?: boolean;
};

const IS_PLAYWRIGHT = typeof window !== 'undefined' ? navigator.webdriver : false;

export default function Loading({ size = 'regular', compact = false }: LoadingProps) {
    return (
        <div
            className={classNames({
                loader: true,
                [`loader-${size}`]: true,
                'loader-compact': compact,
            })}
            data-test-component='ui/Loading'>
            <div
                className='loader-animated'
                style={{ animationPlayState: IS_PLAYWRIGHT ? 'paused' : 'running' }}></div>
        </div>
    );
}
